export default function(value) {
  if (value === undefined) return ''
  const lang = 'ru-RU'
  const options = { style: 'currency', currency: 'RUB', minimumFractionDigits: 0 }
  return value.toLocaleString(lang, options)
}